<template>
  <TosListVuetify :entityName="entityName" :headers="headers" :validateFunction="validate" >
    <template #customFilters="slotProps">
      <v-container fluid>
        <v-row>
          <v-col cols="3">
            <v-text-field label="Codice" v-model="slotProps.data.codice" />
          </v-col>
          <v-col cols="3">
            <v-text-field label="Descrizione" v-model="slotProps.data.descrizione" />
          </v-col>
        </v-row>
      </v-container>
    </template>

    <template #editF="slotProps">
      <div v-if="slotProps.data" class="p-cardialog-content">
        <v-row>
            <v-col cols="4">
              <v-text-field  :label="tLabel('Codice') + '*'" v-model="slotProps.data.codice" :rules="[rules.required]" :error-messages="slotProps.errors.codice"/>
            </v-col>
            <v-col cols="4">
              <v-text-field  :label="tLabel('Nome')" v-model="slotProps.data.nome" :error-messages="slotProps.errors.nome"/>
            </v-col>
            <v-col cols="4">
              <v-text-field  :label="tLabel('Descrizione')" v-model="slotProps.data.descrizione" :error-messages="slotProps.errors.descrizione" />
            </v-col>
        </v-row>      
      </div>
    </template>
  </TosListVuetify>
</template>

<script>
import TosListVuetify from "../../components/anagrafiche/TosListVuetify";
import FormatsMixins from "../../mixins/FormatsMixins";

export default {
  name: "TipiMezzoMovimentazione",
  data() {
    return {
      entityName: "tipiMezzoMovimentazione",
      headers: [
        { text: "", value: "action" },
        { text: "Codice", value: "codice"},
        { text: "Nome", value: "nome"},
        { text: "Descrizione", value: "descrizione" },
      ],
    };
  },
  components: {
    TosListVuetify: TosListVuetify
  },
  mixins: [FormatsMixins],
  methods: {
    validate(item) {
       let errors = {};
       // TODO
       return errors;
    }
  },
};
</script>
